<template>
<div>

    <!-- Header -->
    <div class="header bg-gradient-info py-7  ">
        <b-container>
            <div class="header-body text-center mb-7">
                <b-row class="justify-content-center">
                    <b-col xl="5" lg="6" md="8" class="px-5">
                        <img class="pb-5 logo-img" src="img/brand/green.png">
                        <h1 class="text-dark">Forgot Password</h1>
                    
                    </b-col>
                </b-row>
            </div>
        </b-container>
     
    </div>

    <!-- Page content -->
    <b-container class="mt--8 pb-5">
        <b-row class="justify-content-center">
            <b-col lg="6" md="7">
                <b-card no-body class="bg-color border-5 mb-0">
                    <b-card-body class="px-lg-5 py-lg-5">
                        <validation-observer ref="formValidator">
                            <b-row>
                                <b-col lg="12">
                                    <div class="form-group">
                                         <label class="form-control-label">Enter Email Address</label>
                                <base-input alternative class="mb-2" name="Email" :rules="{required: true, email: true}" prepend-icon="ni ni-email-83" placeholder="Email" >
                                </base-input>
                                    </div>
                                </b-col>
                                <b-col lg="12">
                                    <div class="pt-lg-4 mt-lg-2 float-right">
                                        <b-button variant="primary">Send Reset Link</b-button>
                                        <b-button to="/login" variant="">Back</b-button>
                                    </div>
                                </b-col>
                            </b-row>
                        </validation-observer>
                    </b-card-body>
                </b-card>

            </b-col>
        </b-row>
    </b-container>

</div>
</template>

<script>
export default {

}
</script>

<style scoped>
.logo-img{
    width: 150px;
    height: auto;
}
.bg-color {
background-color: rgb(241, 241, 241) !important;
}
</style>